//model to capture all the search data so that it can be stored in a session

export class SearchData {
    public searchTerm: string;
    public lastPage: string;
}
